export const dornaMail = "@dorna.com";
export const motogpMail = "@motogp.com";
